// extracted by mini-css-extract-plugin
module.exports = {"box":"event-chart_box_2v6Jr","boxWrap":"event-chart_boxWrap_1Soic"};